import {Component, ElementRef, NgZone, OnInit, ViewChild} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import {SettingsProvider} from '@orga-app/settings/settings.service';
import {Settings} from '@orga-app/settings/settings.model';
import {ActionSheetController, LoadingController, ModalController, NavController, ToastController} from '@ionic/angular';
import {getTheme} from '@orga-app/settings/reducer';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {getAktuelleVeranstaltung, GlobalAppState} from '../app-state/app-state.reducer';
import * as apiVeranstaltungen from '../../../clients/veranstaltungen';
import * as actionsUi from './meine-aufgaben.actions.ui';
import {IncidentDetail, IncidentKopf, IncidentsAnzeigeMandantOptions, Rolle, VerlaufEintrag} from '../../../clients/incidents';
import {getDelegationRollen, getEingang, getEingangAbgeschlossen, getEingangLaden, getIncidentDetail, getIncidentDetailLaden, getSelectedIncident, getLetzteMeldungAnzeigen, getLetzteSystemMeldungAnzeigen, getSelectedMeldung} from './meine-aufgaben.selectors';
import {ListInputItem} from '../../shared/sopi-list/sopi-list.model';
import {catchError, filter, takeUntil, takeWhile} from 'rxjs/operators';
import {of, Subject, Subscription} from 'rxjs';
import {BildInfo} from '../../shared/models/bildInfo';
import {ResponseContentType} from '@angular/http';
import {ImageService} from '@orga-app/providers/image.service';
import {getIncidentsMandantOptions} from '@orga-app/mandant/reducer';
import { Router } from '@angular/router';
import {IncidentPage} from '../incident/incident.page';
import {UploadResponse, UploadService} from '../../../clients/api';
import {UuidService} from '@orga-app/providers/uuid.service';
import {BildIdEntfernenAction} from '../incident-leitzentrale/incident-leitzentrale.actions.ui';
import {BildVorschauComponent} from '../../../sopi/components/bild-vorschau/bild-vorschau';
import {DocumentService} from '@orga-app/providers/document.service';
import {NotificationService} from '@orga-app/providers/notification.service';
import {replaceSpecialCharacter} from '../../shared/wrapper/stringWrapper';
import {VeranstaltungselektionPage} from '../veranstaltungsselection/veranstaltungselektion.page';

@Component({
    selector: 'page-meine-aufgaben',
    templateUrl: 'meine-aufgaben.page.html',
    styleUrls: ['./meine-aufgaben.page.scss']
})

export class MeineAufgabenPage implements OnInit {
    @ViewChild('logoFileInput', {static: false, read: ElementRef}) logoFileInput: ElementRef;

    public settings$: Observable<Settings>;
    themeDefault$: Observable<Settings>;
    logoHeaderSVG$: Observable<SafeUrl>;

    public aktuelleVeranstaltung$: Observable<apiVeranstaltungen.Veranstaltung>;
    incidentsMandantOptions$: Observable<IncidentsAnzeigeMandantOptions>;

    eingang$: Observable<Array<ListInputItem>>;
    eingangAbgeschlossen$: Observable<Array<ListInputItem>>;
    eingangLaden$: Observable<boolean>;

    selectedIncident$: Observable<IncidentKopf>;

    incidentDetail$: Observable<IncidentDetail>;
    incidentDetailLaden$: Observable<boolean>;

    delegationRollen$: Observable<Array<Rolle>>;
    abgeschlosseneAnzeigen$: Observable<boolean>;
    letzteMeldungenAnzeigen$: Observable<boolean>;
    letzteSystemMeldungenAnzeigen$: Observable<boolean>;

    selectedMeldung$: Observable<VerlaufEintrag>;

    private incidentBilder: Array<BildInfo> = new Array<BildInfo>();
    incidentBilder$: Observable<BildInfo[]>;
    getIncidentDetail$: Subscription;
    getSelectedMeldung$: Subscription;
    unsubscibe$ = new Subject<void>();
    private alive = true;

    eingangSegment = 'aktuell';
    incidentDetailsSegment = 'klassifizierung';

    image: any;

    meldungsText = '';
    heute: Date;

    constructor(public domSanitizer: DomSanitizer,
                public navCtrl: NavController,
                private store: Store<GlobalAppState>,
                public settingsProvider: SettingsProvider,
                private zone: NgZone,
                private uploadCommandService: UploadService,
                public loadingCtrl: LoadingController,
                private uuiService: UuidService,
                private imageService: ImageService,
                private router: Router,
                private modalCtrl: ModalController,
                private toastCtrl: ToastController,
                private actionsheetCtrl: ActionSheetController,
                private documentService: DocumentService,
                private notificationService: NotificationService
    ) {
        this.themeDefault$ = this.settingsProvider.getThemeDefault();
        this.logoHeaderSVG$ = this.settingsProvider.getLogoHeaderSVG();
        this.settings$ = this.store.pipe(select(getTheme));

        this.aktuelleVeranstaltung$ = this.store.pipe(select(getAktuelleVeranstaltung));
        this.incidentsMandantOptions$ = this.store.pipe(select(getIncidentsMandantOptions));

        this.eingang$ = this.store.pipe(select(getEingang));
        this.eingangAbgeschlossen$ = this.store.pipe(select(getEingangAbgeschlossen));
        this.eingangLaden$ = this.store.pipe(select(getEingangLaden));

        this.selectedIncident$ = this.store.pipe(select(getSelectedIncident));

        this.incidentDetail$ = this.store.pipe(select(getIncidentDetail));
        this.incidentDetailLaden$ = this.store.pipe(select(getIncidentDetailLaden));

        this.selectedMeldung$ = this.store.pipe(select(getSelectedMeldung));

        this.delegationRollen$ = this.store.pipe(select(getDelegationRollen));
        this.letzteMeldungenAnzeigen$ = this.store.pipe(select(getLetzteMeldungAnzeigen));
        this.letzteSystemMeldungenAnzeigen$ = this.store.pipe(select(getLetzteSystemMeldungAnzeigen));

        this.store.dispatch(new actionsUi.PageStateResetAction());
    }

    ngOnInit() {

    }

    ionViewWillEnter() {
        this.heute = new Date();

        const localData = JSON.parse(localStorage.getItem('veranstaltungselektiondata'));
        this.store.dispatch(new actionsUi.SetzeVeranstaltungSelektionLocalDataAction(localData));

        this.store.dispatch(new actionsUi.LoadPageDataAction());

        this.unsubscibe$ = new Subject<void>();
        this.getSelectedMeldung$ = this.store.pipe(select(getSelectedMeldung), takeUntil(this.unsubscibe$)).subscribe((x: VerlaufEintrag) => {
            if (x !== null) {
                this.meldungsText = x.text;
            } else {
                this.meldungsText = '';
            }
        });
        this.getIncidentDetail$ = this.store.pipe(select(getIncidentDetail), takeUntil(this.unsubscibe$)).subscribe((x: IncidentDetail) => {
            this.incidentBilder = [];
            this.incidentBilder$ = of(this.incidentBilder);

            if (x != null && x.bilder_ids !== null && x.bilder_ids.length > 0) {

                x.bilder_ids.forEach(bildId => {
                    this.getIncidentBild(x.incident_id, bildId)
                        .pipe(
                            // tap(y => console.debug(y)),
                            takeWhile(() => this.alive)
                            , filter(image => {
                                return !!image;
                            }),
                            catchError((error: any) => {
                                console.debug('ERROR :: ', error);
                                return of();
                            }),
                        )
                        .subscribe((image: BlobPart) => {
                                const imgtype = bildId.split('.')[1];
                                if (image) {
                                    const blob = new Blob([image]);

                                    const reader = new FileReader();
                                    reader.onload = function () {
                                        const readerResult = reader.result.toString().replace('application/octet-stream', 'image/jpeg');
                                        const imgBase64JPEG = 'data:image/' + imgtype + ';base64,' + readerResult.split('base64,')[1];
                                        const bi = <BildInfo>{
                                            bildId,
                                            data: imgBase64JPEG,
                                            dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(imgBase64JPEG),
                                            type: 'image/' + imgtype
                                        };

                                        this.zone.run(() => {
                                            if (this.incidentBilder.findIndex(y => y.bildId === bi.bildId) === -1) {
                                                this.incidentBilder.push(bi);
                                                this.incidentBilder$ = of(this.incidentBilder);
                                            }
                                        });

                                    }.bind(this);

                                    reader.readAsDataURL(blob);
                                }
                            },
                            error => {

                            });
                });
            }

        });

    }

    ionViewWillLeave() {
        this.unsubscibe$.next();
        this.unsubscibe$.complete();
    }

    getIncidentBild(incidentId: string, bildId: string): Observable<any> {
        const requestOptions = {
            responseType: ResponseContentType.Blob
        };
        return this.imageService.getIncidentBildWithHttpInfo(incidentId, bildId, requestOptions);
    }

    setzeSelektiertenIncident(item: IncidentKopf) {
        this.store.dispatch(new actionsUi.IncidentAusgewaehltAction(item));
    }

    setzeVeranstaltungrelevanz(value: boolean) {
        this.store.dispatch(new actionsUi.SetzeVeranstaltungsrelevantAction(value));
    }

    setzeVerantwortungZentral(value: boolean) {
        this.store.dispatch(new actionsUi.SetzeVerantwortungZentralAction(value));
    }

    setzeVerantwortungAbteilung(abteilungsId: string) {
        this.store.dispatch(new actionsUi.SetzeVerantwortungAbteilungAction(abteilungsId));
    }

    setzeDelegationRolle(rolle: Rolle) {
        this.store.dispatch(new actionsUi.SetzeDelegationRolleAction(rolle));
    }

    eingangNeuLaden() {
        this.store.dispatch(new actionsUi.EingangNeuLadenAction());
    }

    meldungSetzen(value: string) {
        this.store.dispatch(new actionsUi.PostIncidentMeldungSetzenUiAction(value));
        this.meldungsText = '';
    }

    incidentOk() {
        this.store.dispatch(new actionsUi.PostIncidentOkSetzenUiAction());
    }

    incidentNichtOk() {
        this.store.dispatch(new actionsUi.PostIncidentNichtOkSetzenUiAction());
    }

    incidentAbgeben() {
        this.store.dispatch(new actionsUi.PostIncidentAbgebenUiAction());
    }

    incidentUebernehmen() {
        this.store.dispatch(new actionsUi.PostIncidentUebernehmenUiAction());
    }

    setzeAbgeschlosseneAnzeigen($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeAbgeschlosseneAnzeigenAction($event.detail.checked));
    }

    setzeLetzteMeldungenAnzeigen($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeLetzteMeldungenAnzeigenAction($event.detail.checked));
    }

    setzeLetzteSystemMeldungenAnzeigen($event: CustomEvent) {
        this.store.dispatch(new actionsUi.SetzeLetzteSystemMeldungenAnzeigenAction($event.detail.checked));
    }

    async veranstaltungenFiltern() {
        const params = {
            titel: ''
        };
        const modal = await this.modalCtrl.create({component: VeranstaltungselektionPage, componentProps: params});

        modal.onDidDismiss().then((result: any) => {
            const localData = JSON.parse(localStorage.getItem('veranstaltungselektiondata'));

            this.store.dispatch(new actionsUi.SetzeVeranstaltungSelektionLocalDataAction(localData));

            this.store.dispatch(new actionsUi.LoadPageDataAction());
        });

        await modal.present();
    }


    selectMeldung(meldung: VerlaufEintrag) {
        this.store.dispatch(new actionsUi.MeldungAusgewaehltAction(meldung));
    }

    async neuenIncidentAnlegen() {
        const params = {
            titel: ''
        };
        const modal = await this.modalCtrl.create({component: IncidentPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                if (result.data.result) {
                    this.showToastIncidentAngelegt(result.data.message);
                }
            }
        });

        await modal.present();
    }

    async showToastIncidentAngelegt(message: string) {
        const toast = await this.toastCtrl.create({
            message: message,
            duration: 2000
        });
        await toast.present();
    }

    async showMore(incident: IncidentDetail) {
        const buttons = [];
        if (incident.berechtigung.benutzer_ist_manager || !incident.ist_abgeschlossen) {
            buttons.push({
                text: 'Incident bearbeiten',
                icon: 'create',
                handler: () => {
                    this.showIndicentEditModal(incident).then();
                }
            });
        }

        buttons.push({
            text: 'PDF-Export',
            icon: 'download-outline',
            handler: () => {
                // Hier noch export einfügen
                this.downloadPdf(incident).then();
            }
        });

        buttons.push({
            text: 'Abbrechen',
            icon: 'close',
            role: 'cancel',
            handler: () => {
            }
        });

        const actionSheet = await this.actionsheetCtrl.create({
            header: 'Incident Optionen',
            cssClass: 'action-sheets-basic-page',
            buttons
        });
        await actionSheet.present();
    }

    async showIndicentEditModal(incident: IncidentDetail) {
        const params = {
            incidentId: incident.incident_id
        };
        const modal = await this.modalCtrl.create({component: IncidentPage, componentProps: params});
        modal.onDidDismiss().then((result: any) => {
            if (result != null && result.data) {
                if (result.data.result) {
                    this.showToastIncidentAngelegt(result.data.message);
                }
            }
        });

        await modal.present();
    }

    async downloadPdf(incident: IncidentDetail) {
        const loading = await this.loadingCtrl.create({
            spinner: 'dots',
            message: 'Prüfbericht für Incident ' + incident.titel + ' wird geladen'
        });
        await loading.present();

        const url = '/api/incidents/query/reporting/incident/' + incident.incident_id + '/pdf';
        this.documentService.getDocument(url).pipe(
            takeWhile(() => this.alive)
        ).subscribe(async (doc) => {
                if (doc != null) {
                    await loading.dismiss();
                    this.documentService.saveFile(doc, replaceSpecialCharacter(incident.titel));
                }
            },
            async (error) => {
                await this.notificationService.showMessageWithOk('Die Datei konnte nicht geladen werden.');
                await loading.dismiss();
            }, () => {
            });
    }

    async bildAuswahlen() {
        this.logoFileInput.nativeElement.click();
    }

    async bildEinfuegen() {
        // let fi = this.logoFileInput['_native'].nativeElement;
        const fi = this.logoFileInput.nativeElement;
        if (fi.files && fi.files[0]) {
            const fileToUpload = fi.files[0];

            const loading = await this.loadingCtrl.create({
                spinner: 'dots',
                message: 'Das Bild wird hochgeladen ...',
                translucent: true,
                backdropDismiss: false,
                keyboardClose: true
            });

            await loading.present();

            const uploadId = `${this.uuiService.generateUUID()}.jpeg`;
            this.uploadCommandService.postUploadForm(fileToUpload, `incidents`, uploadId).subscribe((result: UploadResponse) => {
                const imgtype = result.upload_id.split('.')[1];
                const bi = <BildInfo>{
                    bildId: result.upload_id,
                    data: fileToUpload,
                    dataTrusted: this.domSanitizer.bypassSecurityTrustUrl(fileToUpload),
                    type: 'image/' + imgtype
                };

                this.store.dispatch(new actionsUi.BildIdHinzufuegenAction(result.upload_id));

                loading.dismiss();
            }, error2 => {
            });
        }
    }

    async bildEntfernen(bildId: string) {
        this.store.dispatch(new BildIdEntfernenAction(bildId));
    }

    async bilderAnzeigen(index) {
        const imageModal = await this.modalCtrl.create({
            component: BildVorschauComponent,
            componentProps: {
                bilder: this.incidentBilder$,
                initialImage: index
            }
        });
        imageModal.onDidDismiss().then(data => console.debug('IncidentLeitzentralePage:: bilderAnzeigen :  imageModal.onDidDismiss: ' + data));
        await imageModal.present();
    }
}
